// Functions
import { setCookie } from "./functions.js";
import { loadPercentage } from "./functions.js";

$(document).ready(function () {
  // инициализирует тултипы
  function bestBkTooltipInit() {
    tippy(".best_bk-rating__info", {
      content: (reference) => reference.nextElementSibling,
      allowHTML: true,
      theme: "bukmekerz--dark",
      animation: "scale",
      interactive: true,
    });
  }

  bestBkTooltipInit();

  let bestBkParams;

  function bestBkRatingInit(isRunTour) {
    $.ajax({
      method: "POST",
      url: "/ajax/bestbkrating",
    }).done(function (res) {
      $("#bestBkResult").html(res);
      bestBkTooltipInit();

      let ratingTableProgress = document.querySelectorAll(
        ".rating__table__stats__item__progress__value"
      );

      loadPercentage(ratingTableProgress);

      if (isRunTour) {
        openFirtsBkItem();
        tourInit();
      }
    });

    $(".best_bk-nav__btn").removeClass("best_bk-nav__btn--active");
    $("#loadRatingBtn").addClass("best_bk-nav__btn--active");
  }

  // копирует текст в буффер обмена
  function copyToClipboard(element, message) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(element).val()).select();
    document.execCommand("copy");
    $temp.remove();

    $.jGrowl(message, { theme: "tickets-message-success" });
  }

  $(".best_bk-promocode__btn").click(function (evt) {
    evt.preventDefault();

    const promocodeWrapper = $(this).parents(".best_bk-promocode");
    const promocodeInput = promocodeWrapper.find(".best_bk-promocode__input");
    copyToClipboard(promocodeInput, "Промокод скопирован");
  });

  $(".bk-card__copy").click(function (evt) {
    evt.preventDefault();

    const promocodeWrapper = $(this).parents(".bk-card__promocode");
    const promocodeInput = promocodeWrapper.find(".bk-card__input");
    copyToClipboard(promocodeInput, "Промокод скопирован");
  });

  function resetMarginSelect() {
    $("#best_bk_margin").val("");
    $("#select2-best_bk_margin-container").text("");
  }

  $("#loadParamsBtn").click(function (evt) {
    evt.preventDefault();
    if (!bestBkParams) {
      $.ajax({
        method: "POST",
        url: "/ajax/bestbkparams",
      }).done(function (res) {
        bestBkParams = res;
        $("#bestBkResult").html(bestBkParams);
      });
    } else {
      $("#bestBkResult").html(bestBkParams);
    }

    resetMarginSelect();
    $(".best_bk-nav__btn").removeClass("best_bk-nav__btn--active");
    $("#loadParamsBtn").addClass("best_bk-nav__btn--active");
  });

  $("#loadRatingBtn").click(function (evt) {
    evt.preventDefault();

    resetMarginSelect();
    bestBkRatingInit();
  });

  const bestBkMargin = [];

  $("#best_bk_margin").on("change", function () {
    let url;

    switch ($(this).val()) {
      case "soccer":
        url = "marginsoccer";
        break;
      case "cybersport":
        url = "margincybersport";
        break;
      case "tennis":
        url = "margintennis";
        break;
      default:
        url = "";
    }

    if (!bestBkMargin[url]) {
      if (url) {
        $.ajax({
          method: "POST",
          url: "/ajax/" + url,
        }).done(function (res) {
          bestBkMargin[url] = res;
          $("#bestBkResult").html(res);
        });
      }
    } else {
      $("#bestBkResult").html(bestBkMargin[url]);
    }

    $(".best_bk-nav__btn").removeClass("best_bk-nav__btn--active");
    $('label[for="best_bk_margin"]').addClass("best_bk-nav__btn--active");
  });

  $("#tourPopupBtn").click(function (evt) {
    evt.preventDefault();

    $("#startTourModal").addClass("modal--active");
    $(".mask").addClass("mask--dark");
    $(".mask").addClass("mask--active");
  });

  // открывает первую карточку БК
  function openFirtsBkItem() {
    // const topRatingTtem = $(".top-rating__item").first();
    // const topRatingBody = topRatingTtem.find(".top-rating__body");
    // topRatingTtem.addClass("top-rating__item--active");
    // topRatingBody.slideDown();

    const bkCard = $(".bk-card").first();
    const bkCardBot = bkCard.find(".bk-card__bot");
    bkCard.addClass("bk-card--active");
    bkCardBot.slideDown();
  }

  function tourInit() {
    $(".modal").removeClass("modal--active");
    $(".mask").removeClass("mask--dark");
    $(".mask").removeClass("mask--active");

    let step3Class;

    if (window.innerWidth < 768) {
      step3Class = ".intro-step-3--mobile";
    } else {
      step3Class = ".intro-step-3";
    }

    // тур
    const introJsOptions = {
      scrollToElement: false,
      tooltipClass: "custom-intro",
      showBullets: false,
      nextLabel: "Далее",
      prevLabel: "Назад",
      doneLabel: "Далее",
      steps: [
        {
          element: document.querySelector(".intro-step-1"),
          intro:
            '<p><span class="white">Cписок БК России</span>, составленный на основе оценок, выставленных экспертами нашего портала. \n' +
            "Под каждым пунктом представлена краткая информация о конторе</p>",
          position: "right",
        },
        {
          element: document.querySelector(".intro-step-2"),
          intro: `
                            <p>
                                <span class="white">Общий рейтинг</span> - оценка букмекера, на основе ключевых факторов (маржа, репутация, роспись и т.д.).
                            </p>
                    `,
          position: "top",
        },
        {
          element: document.querySelector(step3Class),
          intro: `
                            <p>
                                Размер приветственного поощрения.
                                Пометка <span class="white">«Эксклюзив»</span> значит, что букмекер предоставляет дополнительный бонус для читателей нашего портала.
                            </p>
                    `,
          position: "bottom",
        },
        {
          element: document.querySelector(".intro-step-4"),
          intro: `
                            <p>
                                <span class="white">Другая информация:</span> минимальный размер депозита, наличие приложений для смартфонов, дата основание, контакты и т.д.
                            </p>
                    `,
          position: "top",
        },
        {
          element: document.querySelector(".intro-step-5"),
          intro: `
                            <ol>
                                <li>Выбрав букмекера, на основе представленной информации, кликните по кнопке <span class="white">«Играть»</span>, чтобы перейти на сайт БК. </li>
                                <li>Затем нужно <span class="white">зарегистрироваться</span>.</li>
                                <li>Чтобы внести первый <span class="white">депозит</span>, необходимо пройти верификацию, т.е. подтвердить личность</li>
                            </ol>
                    `,
          position: "left",
        },
      ],
    };

    const introTour = introJs();

    introTour.setOptions(introJsOptions);

    $("body").css("overflow", "hidden");

    introTour
      .oncomplete(function () {
        $("body").css("overflow", "visible");
        $("#endTourModal").addClass("modal--active");
        $(".mask").addClass("mask--dark");
        $(".mask").addClass("mask--active");
      })
      .onbeforeexit(function () {
        $("body").css("overflow", "visible");
      })
      .start();
  }

  $("#startTourBtn").click(function (evt) {
    evt.preventDefault();

    if (!$("#bestBkRating").length) {
      // делаем активной влкладку рейтинга
      bestBkRatingInit(true);
    } else {
      // openFirtsBkItem();
      tourInit();
    }
  });

  $("#closeTourBtn").click(function (evt) {
    evt.preventDefault();

    $(".modal").removeClass("modal--active");
    $(".mask").removeClass("mask--dark");
    $(".mask").removeClass("mask--active");
  });

  $(".tour__close").click(function (evt) {
    evt.preventDefault();

    const tour = $(this).parents(".tour");
    tour.fadeOut();

    setCookie("best_bk_tour", "off");
  });
});
